// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2Z3zR","checkboxCol":"Table_checkboxCol__2Uixr","emailCol":"Table_emailCol__SmAMt","actionCol":"Table_actionCol__2fP9u"};